<template>
    <el-popover
        placement="top"
        width="200"
        :disabled="disabled"
        v-model="visible">
        <div class="pop-confirm">
            <div v-if="showStatus" class="pop-confirm-status" :class="[type]">
                <i class="el-icon-warning"></i>
            </div>
            <p class="pop-confirm-text">{{content}}</p>
        </div>
        <div style="text-align: right; margin: 0">
            <el-button size="mini" :type="cancelType" @click="cancel">取消</el-button>
            <el-button :type="confirmType" size="mini" @click="confirm">确定</el-button>
        </div>
        <template slot="reference">
            <slot/>
        </template>
    </el-popover>
</template>

<script>
export default {
  name: 'h-pop-confirm',
  props: {
    content: {
      type: String,
      default: '请设置提示语，谢谢！',
      required: true
    },
    confirmText: {
      type: String,
      default: '确定'
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    type: {
      type: String,
      default: 'warning'
    },
    showStatus: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    cancelType: {
      type: String,
      default: 'text'
    },
    confirmType: {
      type: String,
      default: 'primary'
    }
  },
  data () {
    return {
      visible: false
    }
  },
  methods: {
    cancel (e) {
      this.visible = false
      this.$emit('cancel', e)
    },
    confirm (e) {
      this.visible = false
      this.$emit('confirm', e)
    }
  }
}
</script>

<style lang="less" scoped>
.pop-confirm {
    display: flex;
    align-items: flex-start;
    &-status{
        margin-right: 4px;
        font-size: 16px;
        color: #E6A23C;
        &.success {
            color: #67c23a;
        }
        &.danger {
            color: #f56c6c;
        }
        &.info {
            color: #909399;
        }
        &.primary{
            color: #409bff;
        }
    }
    &-text {
        margin-bottom: 4px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/pop-confirm.vue